import * as React from 'react';

import * as styles from './notification.module.scss';

interface NotificationProps {
  data: string;
}

const Notification = ({data}: NotificationProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.text} dangerouslySetInnerHTML={{__html: data}} />
      </div>
    </div>
  );
};

export default Notification;
